// Ошибки Supabase Auth (GoTrue) по-русски. Сырые английские тексты вроде
// «Invalid login credentials» ученику не показываем (QA 2026-09-24).
// Сначала — по коду ошибки (error.code в supabase-js ≥ 2.4x), затем — по
// тексту: у старых ответов и у ошибок из адреса (/auth/error?error=…) кода нет.

type AuthErrorLike = { message?: string | null; code?: string | null; status?: number | null } | string | null | undefined

const BY_CODE: Record<string, string> = {
  invalid_credentials: 'Неверный email или пароль.',
  email_not_confirmed: 'Email ещё не подтверждён. Откройте письмо со ссылкой, которое мы прислали при регистрации.',
  user_already_exists: 'Аккаунт с таким email уже есть. Войдите или восстановите пароль.',
  email_exists: 'Аккаунт с таким email уже есть. Войдите или восстановите пароль.',
  weak_password: 'Слишком простой пароль. Нужно не меньше 6 символов.',
  over_email_send_rate_limit: 'Слишком много писем за короткое время. Подождите несколько минут и попробуйте снова.',
  over_request_rate_limit: 'Слишком много попыток. Подождите немного и попробуйте снова.',
  over_sms_send_rate_limit: 'Слишком много попыток. Подождите немного и попробуйте снова.',
  email_address_invalid: 'Похоже, в email ошибка. Проверьте адрес.',
  validation_failed: 'Проверьте email и пароль.',
  signup_disabled: 'Регистрация сейчас закрыта.',
  email_provider_disabled: 'Вход по email сейчас недоступен.',
  user_not_found: 'Аккаунт не найден.',
  user_banned: 'Аккаунт заблокирован. Напишите в поддержку.',
  same_password: 'Новый пароль совпадает со старым.',
  otp_expired: 'Ссылка из письма устарела. Запросите новую.',
  flow_state_expired: 'Вход занял слишком долго. Попробуйте ещё раз.',
  session_not_found: 'Сессия закончилась. Войдите снова.',
  bad_jwt: 'Сессия закончилась. Войдите снова.',
}

const BY_TEXT: [RegExp, string][] = [
  [/invalid login credentials/i, BY_CODE.invalid_credentials],
  [/email not confirmed/i, BY_CODE.email_not_confirmed],
  [/user already registered|already been registered/i, BY_CODE.user_already_exists],
  [/password should be at least|weak password/i, BY_CODE.weak_password],
  [/email rate limit/i, BY_CODE.over_email_send_rate_limit],
  [/rate limit|too many requests|security purposes/i, BY_CODE.over_request_rate_limit],
  [/unable to validate email|invalid email|email address .* is invalid/i, BY_CODE.email_address_invalid],
  [/signups? not allowed/i, BY_CODE.signup_disabled],
  [/user not found/i, BY_CODE.user_not_found],
  [/(token|link) (has )?expired|otp.*expired|expired.*(token|link)/i, BY_CODE.otp_expired],
  [/no token hash/i, 'Ссылка из письма неполная. Откройте её из письма ещё раз.'],
  [/failed to fetch|network/i, 'Нет связи с сервером. Проверьте интернет и попробуйте снова.'],
]

const FALLBACK = 'Не получилось. Попробуйте ещё раз.'

export function authErrorText(error: AuthErrorLike): string {
  if (!error) return FALLBACK
  const message = typeof error === 'string' ? error : (error.message ?? '')
  const code = typeof error === 'string' ? null : error.code
  if (code && Object.hasOwn(BY_CODE, code)) return BY_CODE[code]
  for (const [re, text] of BY_TEXT) if (re.test(message)) return text
  // Уже русский текст (наши собственные ошибки) — как есть.
  if (/[а-яё]/i.test(message)) return message
  return FALLBACK
}
